import { GOT_VIDEO } from "../Actions/actionTypes";

export default function(state = {}, { type, payload }) {
  if (type === GOT_VIDEO) return { ...payload };
  return state;
}
